"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var next_1 = require("@alifd/next");
var icon_1 = require("@aligov/icon");
var contextManage_1 = require("../../contextManage");
var gpyUtils_1 = require("./gpyUtils");
var ClassNames = require("classnames");
var rate_1 = require("../../static/images/rate");
var video_error_bg_image_1 = require("../../static/images/video-error-bg-image");
// 拍照组件
var PicCap = function (props) {
    var context = react_1.useContext(contextManage_1.DeviceTaskContext);
    var _a = react_1.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = react_1.useState(''), selectedVideo = _b[0], setSelectedVideo = _b[1];
    var _c = react_1.useState(''), capturedPic = _c[0], setCapturedPic = _c[1];
    var _d = react_1.useState(''), capturedOriginPic = _d[0], setCapturedOriginPic = _d[1];
    var _e = react_1.useState(0), rotate = _e[0], setRotate = _e[1];
    var _f = react_1.useState(true), showCapture = _f[0], setShowCapture = _f[1];
    var _g = react_1.useState([]), devicesList = _g[0], setDevicesList = _g[1];
    var _h = react_1.useState(props.gpyInstance), gpyInstance = _h[0], setGpyInstance = _h[1];
    var isIE = !!window.ActiveXObject || "ActiveXObject" in window;
    react_1.useEffect(function () {
        setGpyInstance(props.gpyInstance);
        var initFun = function () { return __awaiter(_this, void 0, void 0, function () {
            var res, gpySV;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.gpyInstance) return [3 /*break*/, 3];
                        return [4 /*yield*/, getDevices(props.gpyInstance)];
                    case 1:
                        res = _a.sent();
                        console.log("====device list first ===", res);
                        if (!res) return [3 /*break*/, 3];
                        gpySV = localStorage.getItem("gpyVideoSelected");
                        setSelectedVideo(gpySV);
                        console.log("====存储的", gpySV);
                        return [4 /*yield*/, deviceStart(props.gpyInstance, gpySV)];
                    case 2:
                        _a.sent();
                        //再次获取device list 返回包含 value 和 deviceId 保证界面上显示的是友好的
                        getDevices(props.gpyInstance);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var initIeFun = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!props.gpyInstance) return [3 /*break*/, 2];
                        return [4 /*yield*/, deviceStart(props.gpyInstance)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        if (isIE) {
            initIeFun();
        }
        else {
            initFun();
        }
    }, []);
    var getDevices = function (gpyInstance) { return __awaiter(_this, void 0, void 0, function () {
        var res, newList, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, gpyUtils_1.getDevicesList(gpyInstance)];
                case 1:
                    res = _a.sent();
                    console.log("device list", res);
                    if (res) {
                        newList = res.map(function (item) {
                            item.value = item.deviceId;
                            return item;
                        });
                        setDevicesList(newList);
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    next_1.Message.error("设备列表获取失败！");
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deviceStart = function (gpyInstance, selectedVideo) { return __awaiter(_this, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, gpyUtils_1.startDevice(gpyInstance, selectedVideo)];
                case 1:
                    res = _a.sent();
                    console.log("start device", res);
                    if (res) {
                        setSelectedVideo(res.deviceId);
                        localStorage.setItem("gpyVideoSelected", res.deviceId);
                    }
                    else {
                        setSelectedVideo("");
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    setSelectedVideo("");
                    next_1.Message.error("摄像头启用失败，请查看是否启用或者连接设备！");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSelectChange = function (value, actionType, item) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (item.value === selectedVideo) {
                return [2 /*return*/];
            }
            deviceStart(gpyInstance, item.value);
            return [2 /*return*/];
        });
    }); };
    //点击拍摄
    var captureHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("---- captureHandler");
                    //去拍照，同时设置为 loading
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    console.log("--------capture--instance: ", gpyInstance);
                    return [4 /*yield*/, gpyUtils_1.capture(gpyInstance)];
                case 2:
                    res = _a.sent();
                    //拍照成功后
                    if (res && res.url) {
                        console.log("caputre url:", res);
                        setCapturedPic(res.url);
                        setCapturedOriginPic(res.url);
                        setShowCapture(false);
                        setRotate(0);
                    }
                    else {
                        next_1.Message.error("拍摄失败，请重试！");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _a.sent();
                    console.log(error_3);
                    next_1.Message.error("拍摄失败，请重试！");
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    //点击确认
    var pickPicHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        var newList;
        return __generator(this, function (_a) {
            newList = props.gpyPicList.concat([capturedPic]);
            props.setGpyPicList(newList);
            setCapturedPic('');
            setShowCapture(true);
            setRotate(0);
            return [2 /*return*/];
        });
    }); };
    //重新拍照
    var rePickPicHandler = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setCapturedPic('');
            setShowCapture(true);
            setRotate(0);
            return [2 /*return*/];
        });
    }); };
    //图片数目达到最大上限值，置灰为不可用，且鼠标移入右侧有提示
    var fullPicsBtn = React.createElement(next_1.Button, { type: "secondary", disabled: Number(props.gpyTotal) === props.gpyPicList.length },
        React.createElement("span", { className: "icon_pos" },
            React.createElement(icon_1.default, { type: "xiangjipaishe", custom: true, size: "small" })),
        "\u62CD\u6444");
    var videoErrorTips = React.createElement("a", { style: { display: 'inline-block' } }, "\u67E5\u770B\u793A\u610F");
    //点击旋转发生的操作
    var rateHandler = function () {
        var _roate = (rotate + 90) % 360;
        var rateUrl = capturedOriginPic + "?x-oss-process=image/rotate," + _roate + ",image/resize,w_500";
        setRotate(_roate);
        setCapturedPic(rateUrl);
        setShowCapture(false);
    };
    var preViewRender = function () {
        return capturedPic !== "" ?
            React.createElement("div", { className: "preview_div" },
                React.createElement("img", { src: rate_1.default, className: "rateImg", onClick: rateHandler }),
                React.createElement("img", { src: capturedPic, className: "bg_pic" })) : React.createElement("div", null);
    };
    var cls = ClassNames({
        video_stream: true,
        none: !showCapture,
    });
    return (React.createElement("div", { className: "pic_capture" },
        (!isIE ?
            React.createElement("div", { className: "video_select" },
                React.createElement("span", { className: "mr10" }, "\u8BF7\u9009\u62E9\u6444\u50CF\u5934"),
                React.createElement(next_1.Select, { style: { width: '300px' }, dataSource: devicesList, placeholder: "\u8BF7\u9009\u62E9", onChange: onSelectChange, autoHighlightFirstItem: false, value: selectedVideo, defaultValue: selectedVideo, followTrigger: true }))
            :
                React.createElement("div", null,
                    React.createElement(next_1.Message, { type: "notice", shape: "inline", className: "pic_capture_video_error" },
                        "\u82E5\u6444\u50CF\u5934\u4E0D\u6B63\u786E\uFF0C\u8BF7\u5728\u4E0B\u65B9\u62CD\u6444\u7A97\u53E3\u533A\u57DF\u4F7F\u7528\u9F20\u6807\u53F3\u952E\u8FDB\u884C\u8BBE\u7F6E\u3002",
                        React.createElement(next_1.Balloon, { align: "rb", triggerType: "click", trigger: videoErrorTips, popupClassName: "video_error_popup", followTrigger: true },
                            React.createElement("div", { className: "video_error_tips" },
                                React.createElement("img", { src: video_error_bg_image_1.default, width: "100%", height: "100%" })))))),
        React.createElement("div", { className: "pic_capture_div" },
            React.createElement("div", { className: "pic_video_div" },
                React.createElement("div", { className: cls }, gpyUtils_1.domRender(gpyInstance)('create_instnce')),
                preViewRender())),
        (capturedPic !== "" ?
            React.createElement("div", { className: "pic_capture_btn" },
                React.createElement(next_1.Button, { type: "primary", className: "mr10", onClick: pickPicHandler }, "\u786E\u8BA4"),
                React.createElement(next_1.Button, { type: "secondary", onClick: rePickPicHandler }, "\u91CD\u65B0\u62CD\u6444"))
            :
                React.createElement("div", { className: "pic_capture_btn" }, Number(props.gpyTotal) === props.gpyPicList.length ?
                    React.createElement(next_1.Balloon, { align: "r", triggerType: "hover", trigger: fullPicsBtn }, "\u5DF2\u8FBE\u5230\u62CD\u6444\u6570\u91CF\u4E0A\u9650")
                    :
                        React.createElement(next_1.Button, { type: "secondary", onClick: captureHandler, loading: loading, disabled: loading },
                            React.createElement("span", { className: "icon_pos" },
                                React.createElement(icon_1.default, { type: "xiangjipaishe", custom: true, size: "small" })),
                            "\u62CD\u6444")))));
};
exports.default = PicCap;
